import {styled} from 'styled-components'
import TextareaAutosize from 'react-textarea-autosize';


export const StyledButton = styled.button`
  padding: ${({ size }) => (size === 'small' ? '8px 16px' : size === 'large' ? '12px 24px' : '10px 20px')};
  background-color: ${({ bgColor, theme }) => bgColor || theme.primary || '#4f46e5'}; /* Default to indigo-600 */
  color: ${({ textColor, theme }) => textColor || theme.text || '#ffffff'};
  border: ${({ border }) => border || 'none'};
  border-radius: 6px;
  font-size: ${({ size }) => (size === 'small' ? '14px' : size === 'large' ? '18px' : '16px')};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background-color: ${({ bgHover, theme }) => bgHover || theme.primaryHover || '#4338ca'}; /* Slightly darker indigo */
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #d1d5db; /* Gray-300 */
    color: #6b7280; /* Gray-500 */
    cursor: not-allowed;
    opacity: 0.7;
  }
`;


export const Label = styled.label`
  display: block;
    width: ${props => props.width || ""};
  font-size: ${props => props.fontSize || "14px"};
  font-weight: 500;
  color: #374151;
  margin-bottom: ${props => props.mb || '4px'};
`;

export const Input = styled.input`
  width:${props => props.width || '100%'};
  padding: ${props => props.padding || '5px 16px'};
  border: 1px solid ${(props) => (props.error ? '#ef4444' : '#d1d5db')};
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  color: #111827;
  background-color: ${(props) => (props.disabled ? '#f3f4f6' : '#ffffff')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};
  transition: all 0.2s ease-in-out;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;


export const Select = styled.select`
  width: 100%;
  padding: 3px 16px;
  border: 1px solid ${(props) => (props.error ? '#ef4444' : '#d1d5db')};
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-size: 16px;
  color: #111827;
  background-color: ${(props) => (props.disabled ? '#f3f4f6' : '#ffffff')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease-in-out;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%239ca3af' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
  }
`;

export const Textarea = styled(TextareaAutosize)`
width:${props => props.width || '100%'};
  padding: 5px 16px;
  border: 1px solid ${(props) => (props.error ? '#ef4444' : '#d1d5db')};
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  color: #111827;
  background-color: ${(props) => (props.disabled ? '#f3f4f6' : '#ffffff')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};
  transition: all 0.2s ease-in-out;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
  }

  &::placeholder {
    color: #9ca3af;
  }

`;

export const Button = styled.button`
width:${props => props.width || ''};
  padding: 5px 16px;
  border: 1px solid ${(props) => (props.error ? '#ef4444' : '#d1d5db')};
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  color: white;
  background-color: blue;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};
  transition: all 0.2s ease-in-out;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
  }

  &::placeholder {
    color: #9ca3af;
  }

`;


 export const Scroll = styled.div`
width:100%;
 overflow-y:auto;
 text-align:${props => props.textAlign || ""};
 height: ${props => props.height || ""};
 min-height: ${props => props.minHeight || ""};
 max-height: ${props => props.maxHeight || ""};
 position:relative;
 margin: ${props => props.margin || "0px"};
 &::-webkit-scrollbar {
  width: 0rem;
  background-color: #0E425A;
  border-radius: 1rem;


}
 `;

    
export const Flexed = styled.div`
display: ${props => props.display || "flex"};
justify-content: ${props => props.justifycontent || ""};
flex-direction: ${props => props.flexDirection || "row"};
align-items: ${props => props.alignItems || "flex-start"};
position: ${props => props.position || "relative"};
width: ${props => props.width || "100%"};
padding: ${props => props.padding || "0px"};
background-color: ${props => props.bgColor || ""};
border: ${props => props.border || ""};
gap: ${props => props.gap || "5px"};
font-size:${props => props.fontSize || "inherit"};
font-weight:${props => props.fontWeight || ""};
margin: ${props => props.margin || "0px"};
height: ${props => props.height || ""};
border-bottom: ${props => props.borderBottom || ""};
border-bottom: ${props => props.borderbottom || ""};
border-top: ${props => props.borderTop || ""};
color: ${props => props.color || ""};
top: ${props => props.top || ""};
bottom: ${props => props.bottom || ""};
right:${props => props.right || ""};
text-align: ${props => props.textAlign || ""};
letter-spacing:${props => props.letterSpacing || ""};
margin-bottom:${props => props.marginbottom || "0px"};
margin-top:${props => props.marginTop || ""};

flex-wrap:${props => props.flexWrap || ""};
&:hover{
  background:${props => props.hoverbgcolor || ""};
  color:${props => props.hovercolor || ""};

}

`;

export const Flex = styled.div`
flex: ${props => props.flex || "1"};
display: ${props => props.display || ""};
justify-content: ${props => props.justifycontent || ""};
align-items: ${props => props.alignItems || ""};
text-align: ${props => props.textAlign || ""};
height: ${props => props.height || ""};
padding: ${props => props.padding || "0px 4px"};
position:${props => props.position || "relative"};
border: ${props => props.border || ""};
background-color: ${props => props.bgColor || ""};
color: ${props => props.color || "inherit"};
border-bottom: ${props => props.borderBottom || ""};
border-right: ${props => props.borderRight || ""};
border-left: ${props => props.borderLeft || ""};
border-top: ${props => props.borderTop || ""};
border-bottom: ${props => props.borderBottom || ""};
min-width:${props => props.minWidth || ""};
max-width:${props => props.maxWidth || ""};
font-size:${props => props.fontSize || "inherit"};
font-weight:${props => props.fontWeight || ""};
margin: ${props => props.margin || "0px"};
word-break:${props => props.wordBreak || "break-all"};
white-space:${props => props.whiteSpace || ""};
min-height:${props => props.minHeight || ""};
top:${props => props.top || ""};

`;
